// extracted by mini-css-extract-plugin
export default {"headline":"styles__headline__dG1gW","body":"styles__body__TVQpF","leftPane":"styles__leftPane__vvD1P","separator":"styles__separator__HhRwr","rightPane":"styles__rightPane__cFX43"};